import React, { useRef } from 'react';
import moment from 'moment';
import { get_dynamic_styles } from '../../../constant/DynamicStyles';
import { Listing_text } from '../../../constant/Translation/Listing';
import { ConvertDayTranslation } from '../../../utils/ConvertDayTranslation';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Warning from '../../Shared/PopUp/Warning';
import AllIcons from '../../Shared/Constant/Icons/AllIcons';

const ScheduleSelect3 = ({
  dates,
  selectedDate,
  setSelectedDate,
  selectedDateIndex,
  setSelectedDateIndex,
  scheduleArray,
  selectedScheduleTimeIndex,
  setSelectedScheduleTimeIndex,
  styles,
  onScheduleStartDateChange,
}) => {
  let scheduleData;
  if (scheduleArray !== null) {
    scheduleData = scheduleArray[selectedDateIndex];
  }

  const dateRef = useRef(null);
  const openDatePicker = () => {
    dateRef.current.showPicker();
  };

  return (
    <div className="w-full" style={get_dynamic_styles(styles?.main_styles)}>
      <div className="mt-5 flex flex-col md:flex-row justify-between md:items-center gap-2">
        <p className="text-primary text-xl leading-6 font-medium ">
          {Listing_text.productschedule.select_date_time}
        </p>
        <div className="flex items-center gap-2 relative">
          <p>{moment(dates[selectedDateIndex]).format('dddd, MMMM D, YYYY')}</p>
          <button
            type="button"
            className="text-primary"
            onClick={openDatePicker}
          >
            {AllIcons.sm_pencil_icon}
          </button>

          {/* date picker */}
          <input
            type="date"
            ref={dateRef}
            value={selectedDate}
            onChange={(e) => onScheduleStartDateChange(e.target.value)}
            className="absolute top-0 left-0 w-full h-full opacity-0 -z-10"
            min={moment(new Date()).format('YYYY-MM-DD')}
            max={moment().add(1, 'year').format('YYYY-MM-DD')}
          />
        </div>
      </div>

      {/* Date Slider using Swiper */}
      <div className="mt-5 mb-6 px-2 relative">
        <Swiper
          slidesPerView="auto"
          slidesPerGroup={1}
          spaceBetween={16}
          freeMode={true}
          className="w-full"
        >
          {dates?.map((date, i) => (
            <SwiperSlide key={date} style={{ width: '60px' }}>
              <button
                type="button"
                className={`px-3 py-2 rounded-lg border transition-colors duration-200 text-center min-w-[60px] ${
                  i === selectedDateIndex
                    ? ' border-primary text-primary font-semibold'
                    : 'bg-white border-gray-200 text-gray-700'
                }`}
                onClick={() => {
                  setSelectedDateIndex(i);
                  setSelectedDate(moment(date).format('YYYY-MM-DD'));
                  setSelectedScheduleTimeIndex(null);
                }}
              >
                <div className="text-xs font-medium">
                  {moment(date).format('ddd')}
                </div>
                <div className="text-lg font-bold">
                  {moment(date).format('DD')}
                </div>
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Right-side gradient overlay to hint at more slides */}
        <div className="pointer-events-none absolute top-0 right-0 h-full w-8 bg-gradient-to-l from-white/90 to-transparent z-10" />
      </div>
      {/* Time Slots Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {scheduleData && scheduleData.schedules.length > 0 ? (
          scheduleData.schedules.map((item, index) => (
            <button
              key={index}
              disabled={item?.available === false}
              onClick={() =>
                item?.available !== false && setSelectedScheduleTimeIndex(index)
              }
              className={`py-3 rounded-lg border text-center text-base font-medium transition-colors duration-200 focus:outline-none
                ${
                  item?.available === false
                    ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                    : selectedScheduleTimeIndex === index
                    ? 'bg-primary ring-2  ring-primary ring-offset-2  text-white border-primary'
                    : 'bg-white text-gray-800 border-gray-200 hover:border-primary hover:bg-gray-50 cursor-pointer'
                }
              `}
            >
              {item.start_time} - {item.end_time}
            </button>
          ))
        ) : (
          <div className="col-span-3 flex justify-center items-center h-32">
            <Warning
              message={Listing_text.productschedule.on_schedule_available}
              className="mt-5 w-full max-w-sm mx-auto"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ScheduleSelect3;
